import * as React from 'react';

import {Field} from 'redux-form';

import {ErrorMessage} from 'shells/form/error-message';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import {TinyIntroTextField} from '../../fields/tiny-intro-text-field';

import {LOGIN_FORM_USERNAME_FIELD} from '../login-form';
import type {LoginVariant} from '../login-page';
import {MULTI_ACCOUNT_LOGIN_MODES, type MultiAccountLoginMode} from '../types';

import {LoginFlowButton} from './login-flow-button';
import {OauthSection} from './oauth-section';
import {SignupSection} from './signup-section';

type Props = {
    alternateMessage: any;
    handleSubmit: () => any;
    submitting: boolean;
    valid: boolean;
    emailValue: string | null | undefined;
    submitFailed: boolean;
    error: string | null | undefined;
    onGoogleSubmit: (arg1: string) => Promise<any>;
    onMicrosoftSubmit: (arg1?: string | null | undefined) => Promise<any>;
    onMicrosoftIdentityFailure: (arg1?: Error | null | undefined) => void;
    // If Google rejects the identity of the user,
    // i.e. before we even try to authenticate with Nutshell
    onGoogleIdentityFailure: () => void;
    googleErrorMessage: string | null | undefined;
    microsoftErrorMessage: string | null | undefined;
    microsoftOauthUrl: string | null | undefined;
    variant: LoginVariant;
    showSignup: boolean;
    isMobile: boolean;
    loginMode: MultiAccountLoginMode | null;
};

export function SignInPage(props: Props) {
    return (
        <>
            <form onSubmit={props.handleSubmit}>
                {props.alternateMessage || (
                    <>
                        <Header>
                            {props.loginMode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING
                                ? 'Sign back in'
                                : 'Sign in'}
                        </Header>
                        <Subheader>
                            {props.loginMode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING
                                ? 'Choose how you’d like to sign back in.'
                                : 'Choose how you’d like to continue.'}
                        </Subheader>
                    </>
                )}
                {!props.isMobile && (
                    <OauthSection
                        onGoogleSubmit={props.onGoogleSubmit}
                        onMicrosoftSubmit={props.onMicrosoftSubmit}
                        onMicrosoftIdentityFailure={props.onMicrosoftIdentityFailure}
                        onGoogleIdentityFailure={props.onGoogleIdentityFailure}
                        googleErrorMessage={props.googleErrorMessage}
                        microsoftErrorMessage={props.microsoftErrorMessage}
                        microsoftOauthUrl={props.microsoftOauthUrl}
                        googleVariant='login'
                        microsoftVariant='login'
                    />
                )}
                <div className='mt-24'>
                    <Field
                        key='email'
                        name={LOGIN_FORM_USERNAME_FIELD}
                        placeholder='john.appleseed@nutshell.com'
                        title='Email'
                        type='email'
                        autoFocus={true}
                        autocomplete={true}
                        component={TinyIntroTextField}
                        variant='redux-form'
                    />
                </div>
                <LoginFlowButton
                    bttnVariant={props.valid ? 'primary' : 'secondary'}
                    submitting={props.submitting}
                    pageVariant={props.variant}
                />
                {props.submitFailed && props.error && (
                    <div className='my-16'>
                        <ErrorMessage>{props.error}</ErrorMessage>
                    </div>
                )}
            </form>
            {props.showSignup && <SignupSection emailValue={props.emailValue} />}
        </>
    );
}
